import gql from 'graphql-tag';
import apollo from '../apollo';
import { getEntityListWithAccount, getNestedEntityList } from '../../utils/AppUtil';

const REMOVE_CONCURENT_STUDY_MUTATION = gql`
  mutation deleteConcurrentStudy($input: DeleteAllConcurrentStudiesInput!) {
    deleteAllConcurrentStudies(input: $input) {
      accountOwnerId
    }
  }
`;

export const removeConcurrentStudy = (input) =>
  apollo
    .mutate({
      mutation: REMOVE_CONCURENT_STUDY_MUTATION,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

const REMOVE_SIGLE_CONCURENT_STUDY_MUTATION = gql`
  mutation deleteSingleConcurrentStudy($input: DeleteSingleConcurrentStudyInput!) {
    deleteSingleConcurrentStudy(input: $input) {
      accountId
    }
  }
`;

export const removeSingleConcurrentStudy = (input) =>
  apollo
    .mutate({
      mutation: REMOVE_SIGLE_CONCURENT_STUDY_MUTATION,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

const REMOVE_JPS_MUTATION = gql`
  mutation deleteJPS($id: ID!) {
    deleteAllJobProfileSurveys(jobProfile: $id) {
      accountOwnerId
    }
  }
`;

export const removeJPS = (id) =>
  apollo
    .mutate({
      mutation: REMOVE_JPS_MUTATION,
      variables: {
        id,
      },
    })
    .then((res) => res.data);

const REMOVE_SINGLE_JPS_MUTATION = gql`
  mutation deleteSingleJobProfileSurvey($input: DeleteJobProfileSurveyInput!) {
    deleteSingleJobProfileSurvey(input: $input) {
      accountId
    }
  }
`;

export const removeSingleJPS = (input) =>
  apollo
    .mutate({
      mutation: REMOVE_SINGLE_JPS_MUTATION,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

const REMOVE_JOB_PROFILE_MUTATION = gql`
  mutation($input: DeleteJobProfileInput!) {
    deleteJobProfile(input: $input) {
      accountId
    }
  }
`;

export const removeJobProfile = (input) =>
  apollo
    .mutate({
      mutation: REMOVE_JOB_PROFILE_MUTATION,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

const JOB_PROFILE_INVITE_JPS_MUTATE = gql`
  mutation InviteRespondentTakeJPSAssessment($input: InviteRespondentTakeJPSAssessmentInput!) {
    inviteRespondentTakeJPSAssessment(input: $input) {
      jobProfileSurvey {
        id
        status
        startedOn
        respondent {
          id
          firstName
          lastName
          email
        }
        createdOn
        invitedOn
        remindedOn
        declinedOn
        updatedOn
        expiredOn
        useForHints
      }
    }
  }
`;

export const jobProfileInviteJPSMutate = (input) =>
  apollo.mutate({
    mutation: JOB_PROFILE_INVITE_JPS_MUTATE,
    variables: {
      input,
    },
  });

const JOB_PROFILE_REMIND_JPS = gql`
  mutation remindRespondentTakeJPSAssessment($input: RemindRespondentTakeJPSAssessmentInput!) {
    remindRespondentTakeJPSAssessment(input: $input) {
      jobProfileSurvey {
        id
      }
    }
  }
`;

export const jobProfileRemindJPS = (input) =>
  apollo.mutate({
    mutation: JOB_PROFILE_REMIND_JPS,
    variables: {
      input,
    },
  });

const JOB_PROFILE_REMIND_CS = gql`
  mutation($input: RemindRespondentTakeCSAssessmentInput!) {
    remindRespondentTakeCSAssessment(input: $input) {
      clientMutationId
    }
  }
`;

export const jobProfileRemindCS = (input) =>
  apollo.mutate({
    mutation: JOB_PROFILE_REMIND_CS,
    variables: {
      input,
    },
    options: {
      refetchQueries: ['jobProfileCS'],
    },
  });

export const JOB_PROFILE_BY_TEMPLATE_QUERY = gql`
  query GetJobProfiles($accountId: ID!, $first: Int, $filter: JobProfileFilter) {
    account(id: $accountId) {
      id
      jobProfiles(first: $first, filter: $filter) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;

export const getJobProfilesByAssessmentTmpId = (accountId, tempId = null) =>
  apollo
    .query({
      query: JOB_PROFILE_BY_TEMPLATE_QUERY,
      variables: {
        accountId,
        filter: {
          assessmentTemplateId: tempId,
        },
      },
      fetchPolicy: 'network-only',
    })
    .then((res) => {
      const { account } = res.data;
      const processedJobProfiles = getEntityListWithAccount(account, 'jobProfiles');
      return processedJobProfiles;
    });

const SEARCH_JOB = gql`
  query($aid: ID!, $first: Int, $filter: JobProfileFilter, $sort: JobProfileSortSpecifier) {
    account(id: $aid) {
      id
      jobProfiles(first: $first, filter: $filter, sort: $sort) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;

export const searchJobProfile = ({ aid, query = null, tempId = null }) => {
  const sort = {
    sortBy: 'name',
    sortDir: 'ASC',
  };

  const variables = {
    aid,
    first: 1000,
    filter: {
      query,
      assessmentTemplateId: tempId,
    },
    sort,
  };

  return apollo
    .query({
      query: SEARCH_JOB,
      variables,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      const { account } = data;
      const processedJobProfiles = getEntityListWithAccount(account, 'jobProfiles');
      return processedJobProfiles;
    });
};

export const getMassiveJobs = ({ aid }) => {
  const sort = {
    sortBy: 'name',
    sortDir: 'ASC',
  };

  const variables = {
    aid,
    first: 200,
    sort,
  };

  return apollo
    .query({
      query: SEARCH_JOB,
      variables,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      const { account } = data;
      const processedJobProfiles = getEntityListWithAccount(account, 'jobProfiles');
      return processedJobProfiles;
    });
};

const STANDARD_JOB = gql`
  query(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $filter: StandardJobFilter
    $sort: StandardJobSortSpecifier
  ) {
    standardJobs(first: $first, last: $last, before: $before, after: $after, filter: $filter, sort: $sort) {
      edges {
        node {
          id
          name
          industryId
          industryName
        }
      }
    }
  }
`;

export const getStandardJob = (input) => {
  const { query } = input || {};
  const sort = {
    sortBy: 'name',
    sortDir: 'ASC',
  };

  const variables = {
    first: 1000,
    filter: {
      query,
    },
    sort,
  };

  return apollo
    .query({
      query: STANDARD_JOB,
      variables,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      const processedJobProfiles = getNestedEntityList(data, 'standardJobs');
      return processedJobProfiles;
    });
};

const ADD_JOB_PROFILE = gql`
  mutation($input: AddJobProfileInput!) {
    addJobProfile(input: $input) {
      jobProfile {
        id
      }
    }
  }
`;

export const addJobProfile = (input) =>
  apollo
    .mutate({
      mutation: ADD_JOB_PROFILE,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

export const JOB_PROFILE_UPDATE_MUTATE = gql`
  mutation($input: UpdateJobProfileInput!) {
    updateJobProfile(input: $input) {
      jobProfile {
        id
        name
        internalDescription
        updatedOn
      }
    }
  }
`;

export const updateJobProfile = (input) =>
  apollo
    .mutate({
      mutation: JOB_PROFILE_UPDATE_MUTATE,
      variables: {
        input,
      },
      refetchQueries: ['superProfileDetailsQuery'],
    })
    .then((res) => res.data);

export const JOB_PROFILE_DIMENSIONS_UPDATE = gql`
  mutation($input: UpdateJobProfileBenchmarksInput!) {
    updateJobProfileBenchmarks(input: $input) {
      jobProfile {
        id
        dimensionBenchmarks {
          behaviorBenchmarks {
            displayName
            dimensionBenchmarks {
              code
              displayName
              low
              high
            }
          }
          cognitiveBenchmarks {
            displayName
            dimensionBenchmarks {
              code
              displayName
              low
              high
            }
          }
          interestsBenchmarks {
            displayName
            dimensionBenchmarks {
              code
              displayName
              priority
              description
            }
          }
        }
      }
    }
  }
`;

export const updateJobProfileDimension = (input) =>
  apollo
    .mutate({
      mutation: JOB_PROFILE_DIMENSIONS_UPDATE,
      variables: {
        input,
      },
      refetchQueries: ['superProfileDetailsQuery'],
    })
    .then((res) => res.data);

export const JOB_PROFILE_ADD_CS_MUTATE = gql`
  mutation($input: AddConcurrentStudyInput!) {
    addConcurrentStudy(input: $input) {
      clientMutationId
    }
  }
`;

export const AddCSRespondent = (input) =>
  apollo
    .mutate({
      mutation: JOB_PROFILE_ADD_CS_MUTATE,
      variables: {
        input,
      },
      options: {
        refetchQueries: ['jobProfileCS'],
      },
    })
    .then((res) => res.data);

const HINTS_JPS = gql`
  mutation($input: JobProfileSurveyHintsInput!) {
    getJobProfileSurveyHints(input: $input) {
      jobProfileId
      hints {
        id
        high
        low
        priority
        dimensionName
        sectionName
      }
    }
  }
`;

export const useJPSHint = (input) =>
  apollo
    .mutate({
      mutation: HINTS_JPS,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

const HINTS_SJL = gql`
  mutation($input: StandardJobHintsInput!) {
    getStandardJobHints(input: $input) {
      behaviorStandardJobBenchmarks {
        id
        high
        low
        priority
        dimensionName
        sectionName
      }
      cognitiveStandardJobBenchmarks {
        id
        high
        low
        priority
        dimensionName
        sectionName
      }
      interestsStandardJobBenchmarks {
        id
        high
        low
        priority
        dimensionName
        sectionName
      }
    }
  }
`;

export const useSJLHint = (input) =>
  apollo
    .mutate({
      mutation: HINTS_SJL,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

const HINTS_CS = gql`
  mutation GetConcurrentStudyHints($input: ConcurrentStudyHintsInput!) {
    getConcurrentStudyHints(input: $input) {
      jobProfileId
      hints {
        id
        high
        low
        priority
        dimensionName
        sectionName
      }
    }
  }
`;

export const useCSHint = (input) =>
  apollo
    .mutate({
      mutation: HINTS_CS,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

const ADD_EXISTED_RESPONDENT_JPS = gql`
  mutation($input: AddJobProfileSurveyInput!, $first: Int) {
    addJobProfileSurvey(input: $input) {
      jobProfile {
        id
        jobProfileSurveys(first: $first) {
          edges {
            node {
              id
              status
              respondent {
                id
                firstName
                lastName
                email
              }
              useForHints
            }
          }
        }
      }
    }
  }
`;

export const addRespondentToJPS = (input) =>
  apollo
    .mutate({
      mutation: ADD_EXISTED_RESPONDENT_JPS,
      variables: {
        input,
      },
      refetchQueries: ['jobJPS'],
    })
    .then((res) => res.data);

const JOB_CS = gql`
  query($accountId: ID!, $id: ID!, $first: Int) {
    account(id: $accountId) {
      id
      jobProfile(id: $id) {
        id
        concurrentStudies(first: $first) {
          edges {
            node {
              id
              assessment {
                id
                status
                previewInviteUrl
                previewReminderUrl
                startUrl
              }
              respondent {
                id
                firstName
                lastName
                email
              }
              useForHints
            }
          }
        }
      }
    }
  }
`;

const MAX_RECORDS_PER_REQUEST = 200;
export const getConcurrentStudies = ({ jobProfileId, accountId }) => {
  const variables = {
    id: jobProfileId,
    accountId,
    first: MAX_RECORDS_PER_REQUEST,
  };

  return apollo
    .query({
      query: JOB_CS,
      variables,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      const { jobProfile } = data.account;
      const processedJobProfiles = getNestedEntityList(jobProfile, 'concurrentStudies');
      return processedJobProfiles;
    });
};

const JOB_JPS = gql`
  query jobJPS($accountId: ID!, $id: ID!, $first: Int) {
    account(id: $accountId) {
      id
      jobProfile(id: $id) {
        id
        jobProfileSurveys(first: $first) {
          edges {
            node {
              id
              respondent {
                id
                firstName
                lastName
                email
              }
              startUrl
              previewInviteUrl
              previewReminderUrl
              status
              useForHints
              scheduledForDeletionOn
            }
          }
        }
      }
    }
  }
`;

export const getJobProfileSurveys = ({ jobProfileId, accountId }) => {
  const variables = {
    id: jobProfileId,
    accountId,
    first: MAX_RECORDS_PER_REQUEST,
  };

  return apollo
    .query({
      query: JOB_JPS,
      variables,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      const { jobProfile } = data.account;
      const processedJobProfiles = getNestedEntityList(jobProfile, 'jobProfileSurveys');
      return processedJobProfiles;
    });
};

const INVITE_CS = gql`
  mutation($input: InviteRespondentTakeCSAssessmentInput!) {
    inviteRespondentTakeCSAssessment(input: $input) {
      clientMutationId
    }
  }
`;

export const inviteCS = (input) =>
  apollo
    .mutate({
      mutation: INVITE_CS,
      variables: {
        input,
      },
      options: {
        refetchQueries: ['jobProfileCS'],
      },
    })
    .then((res) => res.data);

const SUGGEST_JOB_PROFILE = gql`
  mutation($input: JobProfileSuggestionInput!) {
    suggestJobProfileHints(input: $input) {
      clientMutationId
      dimensionSuggestionBehavior {
        code: dimensionName
        high
        low
      }
      dimensionSuggestionCognitive {
        code: dimensionName
        high
        low
      }
      dimensionSuggestionInterest {
        code: dimensionName
        description
        priority
      }
    }
  }
`;
export const suggestJobProfileDimension = (input) =>
  apollo
    .mutate({
      mutation: SUGGEST_JOB_PROFILE,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

const JOB_PROFILE_TOGGLE_JPS = gql`
  mutation($input: ToggleUseForHintsInput!) {
    toggleJobProfileSurvey(input: $input) {
      value
    }
  }
`;
export const toggleUsingJPS = (input) =>
  apollo
    .mutate({
      mutation: JOB_PROFILE_TOGGLE_JPS,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

const JOB_PROFILE_TOGGLE_CS = gql`
  mutation($input: ToggleUseForHintsInput!) {
    toggleConcurrentStudy(input: $input) {
      value
    }
  }
`;
export const toggleUsingCS = (input) =>
  apollo
    .mutate({
      mutation: JOB_PROFILE_TOGGLE_CS,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

export const GET_JPS_URL = gql`
  query getJpsUrl($assessmentId: ID!, $accountId: ID!) {
    getJpsUrl(assessmentId: $assessmentId, accountId: $accountId)
  }
`;

export const previewJPS = ({ accountId, assessmentId }) =>
  apollo
    .query({
      query: GET_JPS_URL,
      variables: {
        assessmentId,
        accountId,
      },
    })
    .then((res) => res.data);

export const jobMatchResult = (input) => {
  const JOB_MATCHED_QUERY = gql`
    mutation matchedResults($accountId: ID!, $jobProfileId: ID!, $assessmentId: ID!, $locale: Locale!) {
      jobProfileMatchResults(
        accountId: $accountId
        jobProfileId: $jobProfileId
        assessmentId: $assessmentId
        locale: $locale
      ) {
        jobProfileId
        assessmentId
        overallMatch
      }
    }
  `;
  return apollo
    .mutate({
      mutation: JOB_MATCHED_QUERY,
      variables: {
        ...input,
      },
    })
    .then((res) => res.data);
};

export const TOGGLE_CS = gql`
  mutation($input: ToggleUseForHintsInput!) {
    toggleConcurrentStudy(input: $input) {
      value
    }
  }
`;

export const jobProfileToggleCS = (input) =>
  apollo
    .mutate({
      mutation: TOGGLE_CS,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

export const TOGGLE_JPS = gql`
  mutation($input: ToggleUseForHintsInput!) {
    toggleJobProfileSurvey(input: $input) {
      value
    }
  }
`;

export const jobProfileToggleJPS = (input) =>
  apollo
    .mutate({
      mutation: TOGGLE_CS,
      variables: {
        input,
      },
    })
    .then((res) => res.data);

const UPDATE_STANDARD_JOB = gql`
  mutation($input: UpdateJobProfileStandardJobInput!) {
    updateJobProfileStandardJob(input: $input) {
      jobProfile {
        id
        standardJob {
          id
          industryId
        }
      }
    }
  }
`;

export const updateJobProfileStandJob = (input) =>
  apollo
    .mutate({
      mutation: UPDATE_STANDARD_JOB,
      variables: {
        input,
      },
    })
    .then((res) => res.data);
